import { Paper } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import ReportCategory from './ReportCategory/ReportCategory';
import styles from './ReportContent.module.scss';
import { useEffect } from 'react';

const ReportContent = ({
	categories,
	setCognosApi,
	setDashboardAPI,
	setReportUniqueName,
	setReportTitle,
	setReportDbIndex,
	search,
	loading,
	cognosApi,
	reportTitle,
}) => {
	return (
		<Paper className={styles.reporting_content_wrapper} id='ddeDashboard'>
			{!loading && !reportTitle && (
				<>
					{categories.map((category) => (
						<ReportCategory
							title={category.name}
							key={category.id}
							categoryId={category.id}
							setCognosApi={setCognosApi}
							setDashboardAPI={setDashboardAPI}
							setReportUniqueName={setReportUniqueName}
							setReportTitle={setReportTitle}
							setReportDbIndex={setReportDbIndex}
							search={search}
							cognosApi={cognosApi}
						/>
					))}
				</>
			)}
		</Paper>
	);
};

const mapStateToProps = (state) => ({
	categories: state.reporting.categories,
	loading: state.reporting.loading,
});

export default connect(mapStateToProps)(ReportContent);
